import { render, staticRenderFns } from "./Preguntas.vue?vue&type=template&id=0641c5e8"
import script from "./Preguntas.vue?vue&type=script&lang=js"
export * from "./Preguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0641c5e8')) {
      api.createRecord('0641c5e8', component.options)
    } else {
      api.reload('0641c5e8', component.options)
    }
    module.hot.accept("./Preguntas.vue?vue&type=template&id=0641c5e8", function () {
      api.rerender('0641c5e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/Preguntas.vue"
export default component.exports